import axios from 'axios';
import config from '../../config/config';
import {  makeDynamicUrlPreserveProtoPort } from '../helpers/get-base-domain';
import store from '../../store/configure-store';
import { setSessionStale } from '../../store/entities/session-stale-slice';


// seed URL (zbog protokola i PORTA iz configa)
const configuredServer =
  (config?.default?.gameServers);

let dynamicServerUrl = configuredServer;

if (typeof window !== 'undefined') {
  const host = window.location.hostname;
  // ako smo na localhostu, ostaje stari config
  if (host !== 'localhost' && host !== '127.0.0.1') {
    dynamicServerUrl = makeDynamicUrlPreserveProtoPort(configuredServer);
  }
}
export const apiClient = axios.create({
  
   baseURL: dynamicServerUrl,
  validateStatus: (status) => status >= 200 && status < 300,
});

// Add a request interceptor
apiClient.interceptors.request.use((cfg) => {
  cfg.headers = { 'Content-Type': 'application/json' };

  // Add default `game_id` to the request body if it's not already included
  if (!cfg.data) {
    cfg.data = {};
  }
  if (typeof cfg.data === 'object' && !cfg.data.game_id) {
    cfg.data.game_id = Number(process.env.REACT_APP_GAME_ID) || 105;
  }

  return cfg;
});


apiClient.interceptors.response.use(
  (response) => {
    if (response.data?.Action === 'DISCONNECT') {
      store.dispatch(setSessionStale());
    }
    return response;
  },
  (error) => {
    if (!error.response) {
      return Promise.reject(error);
    }
    const { data, status } = error.response;
    if (status === 401 && data?.Action === 'DISCONNECT') {
      store.dispatch(setSessionStale());
    }
    return Promise.reject({ status, data });

});

export default apiClient;
